/** Роли Discord, дающие доступ к сайту (регистрация, вход, сессия). */
export const SITE_ACCESS_ROLES = [
  'admin',
  'Chief Manager',
  'Deputy Chief Manager',
  'Senior Manager',
];

export function hasSiteAccess(userRoles) {
  if (!Array.isArray(userRoles)) return false;
  return SITE_ACCESS_ROLES.some((role) => userRoles.includes(role));
}

export function formatSiteAccessRoles() {
  return SITE_ACCESS_ROLES.join(', ');
}
